export const CYCLE_TYPE_NONE = 'NONE';
export const CYCLE_TYPE_REGULAR = 'REGULAR';
export const CYCLE_TYPE_IRREGULAR = 'IRREGULAR';
export const CYCLE_TYPE_PREGNANT = 'PREGNANT';
export const CYCLE_TYPE_INACTIVE = 'INACTIVE';
export const CYCLE_MIN_LENGTH = 2;
export const CYCLE_MAX_LENGTH = 365;
export const DATE_FORMAT = 'YYYY-MM-DD';
export const NUMBER_OF_MONTHS_TO_LAZY_LOAD_BEHIND = 12;
export const NUMBER_OF_MONTHS_TO_LAZY_LOAD_AHEAD = 6;
export const HORMONAL_CONTRACEPTION_NONE = 'NONE';
export const NUMBER_OF_DAYS_BETWEEN_CYCLES = 6;
export const DEFAULT_PERIOD_LENGTH = 5;
export const MAXIMUM_CYCLE_LENGTH_FOR_PERIOD_PREDICTION = 100;
export const MAXIMUM_CYCLE_LENGTH_FOR_FERTILE_WINDOW_PREDICTION = 45;
export const MINIMUM_CYCLE_LENGTH_FOR_FERTILE_WINDOW_PREDICTION = 20;
export const CONTRACEPTION_TYPE_CONTRACEPTIVE_INJECTIONS = 'CONTRACEPTIVE_INJECTIONS';
export const CONTRACEPTION_TYPE_CONTRACEPTIVE_PATCH = 'CONTRACEPTIVE_PATCH';
export const CONTRACEPTION_TYPE_IUD = 'IUD';
export const CONTRACEPTION_TYPE_IMPLANT = 'IMPLANT';
export const CONTRACEPTION_TYPE_ORAL_CONTRACEPTION = 'ORAL_CONTRACEPTION';
export const CONTRACEPTION_TYPE_VAGINAL_RING = 'VAGINAL_RING';
export const CONTRACEPTION_TYPE_NONE = 'NONE';
